export const ROLE_STS = "stsStandardRole";
export const RESOURCE_ACCESS_STS = "sts";
export const OPERATOR = "Operator";
export const RESOURCE_ACCESS_PORTALE_GA = "portale-ga";
